import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.cuenta.hits.balance = {
      ...state.cuenta.hits.balance,
      ...data,
    };
  });
};

const submit = async (store) => {
  store.setState((state) => {
    state.cuenta.hits.balance.busy = true;
  });

  const data = { ...store.state.cuenta.hits.balance.data };

  try {
    const response = await Http.patch('/auth/me/hits', data);

    store.setState((state) => {
      state.cuenta.hits.balance.busy = false;
      state.cuenta.hits.balance.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.hits.balance.busy = false;
      state.cuenta.hits.balance.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.cuenta.hits.balance = { ...initialState };
  });
};

const ConfiguracionHitsBalanceStore = {
  state: () => initialState,
  actions: {
    change,
    submit,
    reset,
  },
};

export default ConfiguracionHitsBalanceStore;
